import { gameService } from '../apiServices/GameService';


class PartnerService {
  constructor() {
    this._partnerId = 4;
    this._currency = 'FUN';
    this._language = 'en';
  }

  demoInit() {
    this._currency = 'FUN';
  }

  realInit() {
    this._currency = 'FUN';
  }

  get language() {
    return this._language;
  }

  set language(val) {
    if (val) {
      this._language = val;
    }
  }

  set currency(code) {
    this._currency = code;
    return this._currency;
  }

  get partnerId() {
    return this._partnerId;
  }

  set partnerId(value) {
    this._partnerId = value;
  }

  get currency() {
    return this._currency;
  }

  get displayCurrency() {
    if (this.currency) {
      return this.currency;
    }
    return 'FUN';
  }
}

export const partnerService = new PartnerService();
